// The core dispatcher for the dom ready event javascript.

import debounce from 'debounce-fn';

import resize from './resize';
import viewportDims from './viewport-dims';
import applyBrowserClasses from '../utils/dom/apply-browser-classes';

import navigation from '../navigation/index';
import modules from '../modules/index';
import loop from '../loop/index';
import panels from '../panels/index';

// Bind global event listeners here,
function bindEvents() {
	let callback = debounce(resize, { wait: 200 });

	// see https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API
	if (typeof window.visualViewport != 'undefined') {
		window.visualViewport.addEventListener('resize', callback);
	} else {
		window.addEventListener('resize', callback);
	}
}

// The core dispatcher for init across the codebase.
export function init() {
	return Promise.resolve()
		.then(applyBrowserClasses) // apply browser classes
		.then(viewportDims) // set initial states
		.then(bindEvents) // initialize global events
		.then(navigation) // navigation
		.then(modules) // initialize the module scripts
		.then(loop) // initialize the main scripts
		.then(panels) // initialize any panels on the page
		.then(logReadyMessage);
}

function logReadyMessage() {
	console.info('Initialized all javascript that targeted document ready.');
}
